// Side-effect module: runs before `./router` snapshots the location (see `src/index.tsx`).
import { resumeScreenAfterSignOut } from './screenAfterSignOut';

resumeScreenAfterSignOut();
